import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  returnCounter: {
    description: 'Label indicating a specific return',
    defaultMessage: 'Return {counter}{isNewReturn, select, true { (New)} other {}}',
    id: 'f2Tymm',
  },
});

const ReturnCounter = ({ counter, isNewReturn = false }) => (
  <FormattedMessage {...messages.returnCounter} values={{ counter, isNewReturn }} />
);

export { ReturnCounter };

ReturnCounter.propTypes = {
  counter: PropTypes.number.isRequired,
  isNewReturn: PropTypes.bool,
};
